import React from "react";

const Button = ({ type = "primary", text, icon, onClick, classes = "", disabled }) => {
    const baseClasses =
        "group relative inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full font-semibold text-base md:text-lg overflow-hidden transition-all duration-300 active:scale-95";

    const typeClasses =
        type === "primary"
            ? "bg-primary text-white hover:scale-105 hover:shadow-[0_0_40px_rgba(74,112,169,0.5)]"
            : "bg-transparent border hover:scale-105 border-primary text-text-light hover:bg-primary hover:text-white";

    return (
        <button
            className={`${baseClasses} ${typeClasses} ${classes}`}
            onClick={onClick}
            disabled={disabled}
        >
            <span className="relative z-10">{text}</span>
            {icon && <span className="relative z-10 w-5 h-5">{icon}</span>}

            {type === "primary" && (
                <span className="absolute inset-0 translate-x-[-100%] group-hover:translate-x-[100%] bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-700"></span>
            )}
        </button>
    );
};

export default Button;
